import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(3),
    },
    title: {
        fontSize: '1.35rem',
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    countChip: {
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 22,
    },
}));

export interface SectionHeadingProps {
    title: string;
    /** When undefined, the count chip is hidden. */
    count?: number;
    automationId?: string;
}

/**
 * Standard heading for Instance Detail sections. Renders the title and an
 * optional count chip so users can see how many items the section contains
 * without scrolling into it.
 */
export const SectionHeading = ({ title, count, automationId }: SectionHeadingProps) => {
    const { classes } = useStyles();
    return (
        <Box className={classes.root}>
            <Typography variant="h5" className={classes.title}>
                {title}
            </Typography>
            {count !== undefined && (
                <Chip
                    size="small"
                    label={count}
                    color="default"
                    className={classes.countChip}
                    automation-id={automationId}
                />
            )}
        </Box>
    );
};
